export type BuildInfo = {
  version: string;
  branch: string;
  sha: string;
  buildTime: string;
};

export function getBuildInfo(): BuildInfo {
  const version = process.env.REACT_APP_VERSION || 'dev';
  const branch = process.env.REACT_APP_GIT_BRANCH || 'local';
  const fullSha = process.env.REACT_APP_GIT_SHA || '';
  const sha = fullSha.substring(0, 7);
  const buildTime = process.env.REACT_APP_BUILD_TIME || '';

  return { version, branch, sha, buildTime };
}
